import { COMMON } from './common'

/**
 * What a comment list says about itself.
 *
 * One list, wherever comments are kept — a document, a position — so the empty
 * state and the buttons are worded once. What the list is _about_ is the
 * surface's own heading.
 */
export const COMMENTS = {
  heading: 'Kommentare',
  empty: 'Noch kein Kommentar',
  placeholder: 'Kommentar schreiben …',
  submit: 'Kommentieren',
  /** Said in place of an author: a note the system recorded, and one whose
   *  author no longer has an account. The two are different facts. */
  bySystem: 'System',
  byDeletedUser: COMMON.deletedAccount,
  errors: {
    isARecord:
      'Diesen Kommentar hat das System festgehalten. Er lässt sich nicht ändern und nicht löschen.',
  },
} as const
